import React, {Component} from "react";
import outlineBG from "./images/Spear_v06_SpearFill.svg"
import outline from "./images/Spear_v06_SpearOutline.png"
import gradient from "./images/Spear_v06_Gradient.png"
import {formatMoney} from "../../containers/Applications/shared/shared";

export class SpearGauge extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: 0
    }
  }

  componentDidMount() {
    if (this.props.value === undefined) {
      setInterval(() => {
        const randVal = Math.floor(Math.random() * 100);
        this.setState({value: randVal})
      }, 2000)
    } else {
      setTimeout(() => {
        this.setState({value: this.props.value})
      }, 1000);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.value !== this.props.value) {
      setTimeout(() => {
        this.setState({value: this.props.value})
      }, 1000);
    }
  }

  lineGenerators() {
    if (this.props.separatorLines) {
      return [{display: "", val: 0}, ...this.props.separatorLines.map((line) => {
        return {
          ...line
        }
      })];
    } else {
      return []
    }
  }

  intervalGenerators() {
    if (this.props.lineInterval) {
      let lineInterval = this.props.lineInterval;
      let response = [];
      let interval = 100 / (lineInterval.steps || 10);
      for (let i = 0; i <= (lineInterval.steps || 10); i++) {
        if (lineInterval.money) {
          let value = i * (lineInterval.spaced || 10);
          // Math.floor(line.val / maxVal * 10000) / 100
          let suffix = "";
          if (value >= 1000) {
            value /= 1000;
            suffix = "K"
          }
          if (value >= 1000) {
            value /= 1000;
            suffix = "M"
          }
          response.push({
            display: `$${formatMoney(value)}${suffix}`,
            val: i * interval
          });
        } else {
          response.push({display: `${i * (lineInterval.spaced || 10)}`, val: i * interval});
        }
      }
      return response;
    } else {
      return [];
    }
  }

  render() {

    // let value = this.props.value || this.state.value
    let value = this.state.value

    if (value < 0) value = 0;
    if (value > 100) value = 100;

    const MAX = 10;
    const ZERO = 187;

    function intervalCalc(valu) {
      return ZERO - Math.abs((MAX - ZERO) / 100 * valu)
    }

    const val = intervalCalc(value);
    // console.log((MAX - ZERO))
    // console.log((MAX - ZERO) / 100)
    // console.log(val)

    return <div style={{
      height: 200,
      width: 200,
      position: "relative",
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: "10%"
    }}>
      <img src={outlineBG} height={200} width={200} style={{position: "absolute", top: 0, left: 0}}/>
      <div style={{
        position: "absolute", top: 0, left: 0, height: 200, width: 200, overflow: "hidden",
        clip: `rect(${val}px, auto, auto, 0)`,
        transition: "clip 1s"
      }}>
        <img src={gradient} height={200} width={200} style={{position: "absolute", top: 0, left: 0}}/>
      </div>
      <img src={outline} height={200} width={200} style={{position: "absolute", top: 0, left: 0}}/>
      {this.lineGenerators().map((line, index) => {
        return <div
          key={`${index}`}
          style={{
            position: "absolute",
            top: intervalCalc(line.val),
            left: 0,
            height: 200,
            width: 75,
            marginLeft: 125,
            borderTop: "1px solid white",
            fontSize: value >= line.val ? 14 : 11,
            fontWeight: value >= line.val ? "bolder" : "normal",
            color: value >= line.val ? "greenyellow" : "white",
            transition: "1s",
            overflowWrap: "normal"
          }}>{line.display}</div>
      })}
      {this.intervalGenerators().map((line, index) => {
        return <div
          key={`${index}`}
          style={{
            position: "absolute",
            top: intervalCalc(line.val),
            left: 0,
            height: 200,
            width: 75,
            marginLeft: 0,
            borderTop: "1px solid white",
            fontSize: 10,
            overflowWrap: "normal"
            // fontSize: value >= line.val ? 11 : "unset",
            // fontWeight: value >= line.val ? "bolder" : "normal",
            // color: value >= line.val ? "greenyellow" : "white",
            // transition: "1s"
          }}>{line.display}</div>
      })}
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/SpearGauge/SpearGauge.js